// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/logo_tc_black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/logo_tc.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.theme-1 img.nav-logo-icon,
body.theme-1 img.nav-lateral-logo-icon {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

body.theme-2 img.nav-logo-icon,
body.theme-2 img.nav-lateral-logo-icon {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

#mainMenu {
    box-shadow: 0 0.1rem 2.5rem 0.5rem rgb(var(--shadow-rgb) / 40%);
}

.navbar-brand {
    max-width: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/mainNav/style.css"],"names":[],"mappings":"AAAA;;IAEI,gDAA8C;AAClD;;AAEA;;IAEI,gDAAwC;AAC5C;;AAEA;IACI,+DAA+D;AACnE;;AAEA;IACI,eAAe;AACnB","sourcesContent":["body.theme-1 img.nav-logo-icon,\r\nbody.theme-1 img.nav-lateral-logo-icon {\r\n    content: url(\"../../images/logo_tc_black.svg\");\r\n}\r\n\r\nbody.theme-2 img.nav-logo-icon,\r\nbody.theme-2 img.nav-lateral-logo-icon {\r\n    content: url(\"../../images/logo_tc.svg\");\r\n}\r\n\r\n#mainMenu {\r\n    box-shadow: 0 0.1rem 2.5rem 0.5rem rgb(var(--shadow-rgb) / 40%);\r\n}\r\n\r\n.navbar-brand {\r\n    max-width: 30px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
